import React from "react";
import ReactDatePicker from "react-datepicker";
import {
  subDays,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  subMonths,
  subQuarters,
  isValid,
  min,
  max,
} from "date-fns";
import Select from "../common/select";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

export default function DateSelector({ updateRange }) {
  const [showRangeSelect, setShowRangeSelect] = React.useState(false);
  const [internalRange, setInternalRange] = React.useState({
    start: subDays(new Date(), 30),
    end: new Date(),
  });
  const dateOptions = [
    { label: "Last 30 days", value: "last_30" },
    { label: "Month to Date", value: "month_to_date" },
    { label: "Last Month", value: "last_month" },
    { label: "Last Quarter", value: "last_quarter" },
    { label: "Quarter to Date", value: "quarter_to_date" },
    { label: "Custom", value: "custom" },
  ];

  const now = new Date();

  const presetDateRanges = {
    last_30: {
      start: subDays(now, 30),
      end: now,
    },

    month_to_date: {
      start: startOfMonth(now),
      end: now,
    },

    last_month: {
      start: startOfMonth(subMonths(now, 1)),
      end: endOfMonth(subMonths(now, 1)),
    },

    last_quarter: {
      start: startOfQuarter(subQuarters(now, 1)),
      end: endOfQuarter(subQuarters(now, 1)),
    },

    quarter_to_date: {
      start: startOfQuarter(now),
      end: now,
    },
  };

  function onOptionSelect(option) {
    if (option.value !== "custom") {
      setShowRangeSelect(false);
      updateRange(presetDateRanges[option.value]);
    } else {
      setShowRangeSelect(true);
    }
  }

  function onDateRangeChange(date, field) {
    const { start, end } = internalRange;

    // If the incoming date is invalid, no change
    if (!(date instanceof Date) || !isValid(date)) {
      return;
    }

    if (field === "start") {
      const newStart = date;

      setInternalRange({
        start: min([newStart, end]),
        end: max([newStart, end]),
      });
      updateRange({
        start: min([newStart, end]),
        end: max([newStart, end]),
      });
      return;
    }

    if (field === "end") {
      const newEnd = date;

      setInternalRange({
        start: min([start, newEnd]),
        end: max([start, newEnd]),
      });
      updateRange({
        start: min([start, newEnd]),
        end: max([start, newEnd]),
      });
      return;
    }

    return;
  }

  return (
    <React.Fragment>
      <Select
        name="date"
        options={dateOptions}
        defaultValue={dateOptions[0]}
        onChange={(option) => onOptionSelect(option)}
        classNamePrefix="react-select"
      />
      <CalendarMonthRoundedIcon />

      {showRangeSelect ? (
        <React.Fragment>
          <ReactDatePicker
            selected={internalRange.start}
            onChange={(date) => onDateRangeChange(date, "start")}
            clearIcon={null}
            dateFormat="yyyy-MM-dd"
          />
          <ArrowForwardRoundedIcon />

          <ReactDatePicker
            selected={internalRange.end}
            onChange={(date) => onDateRangeChange(date, "end")}
            clearIcon={null}
            dateFormat="yyyy-MM-dd"
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}
